/** Tipos del cliente HTTP. Todas las llamadas devuelven ApiResult<T>: nunca lanzan. */
export interface Paginated<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  links: { next: string | null; previous: string | null };
}

export interface ApiError {
  ok: false;
  /** 0 = sin red / respuesta ilegible. */
  status: number;
  /** Clave i18n (errors.*) o texto literal del servidor. */
  title: string;
  detail: string;
  /** Código de máquina del backend nuevo (p. ej. "credenciales_invalidas"). */
  code?: string;
  fieldErrors?: Record<string, string>;
  /** Datos adicionales del backend (p. ej. la versión actual en un 409 `version_desfasada`). */
  extra?: unknown;
}

export interface ApiOk<T> {
  ok: true;
  data: T;
  /** Cabeceras relevantes (p. ej. ETag) por si el llamador las necesita. */
  headers?: Record<string, string>;
}

export type ApiResult<T> = ApiOk<T> | ApiError;

export const isOk = <T>(r: ApiResult<T>): r is ApiOk<T> => r.ok === true;
export const isErr = <T>(r: ApiResult<T>): r is ApiError => r.ok === false;
